import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import {
    CloseModalAction,
    isOpenModalAction,
    OpenModalAction,
    SUBSCRIPTION_MODAL_MODE,
    SubscriptionModalStore,
} from './typings';

const initialState: SubscriptionModalStore = {
    opened: false,
    loadingStatuses: {},
    mode: SUBSCRIPTION_MODAL_MODE.SUBSCRIBE,
};

const slice = createSlice({
    name: 'LESSON_SUBSCRIPTION_MODAL',
    initialState,
    reducers: {
        toggleSubscriptionModal: (state, action: PayloadAction<OpenModalAction | CloseModalAction>) => {
            const { opened } = action.payload;

            if (isOpenModalAction(action.payload)) {
                state.mode = action.payload.mode;
            }

            state.opened = opened;
        },
        confirmSubscriptionRequest: (state, action: PayloadAction<{ slug: string }>) => {
            const { slug } = action.payload;
            state.loadingStatuses[slug] = LOADING_STATUSES.LOADING;
        },
        confirmSubscriptionSuccess: (state, action: PayloadAction<{ slug: string }>) => {
            const { slug } = action.payload;
            state.loadingStatuses[slug] = LOADING_STATUSES.SUCCESS;
        },
        confirmSubscriptionError: (state, action: PayloadAction<{ slug: string }>) => {
            const { slug } = action.payload;
            state.loadingStatuses[slug] = LOADING_STATUSES.ERROR;
        },
        confirmUnsubscriptionRequest: (state, action: PayloadAction<{ slug: string }>) => {
            const { slug } = action.payload;
            state.loadingStatuses[slug] = LOADING_STATUSES.LOADING;
        },
        confirmUnsubscriptionSuccess: (state, action: PayloadAction<{ slug: string }>) => {
            const { slug } = action.payload;
            state.loadingStatuses[slug] = LOADING_STATUSES.SUCCESS;
        },
        confirmUnsubscriptionError: (state, action: PayloadAction<{ slug: string }>) => {
            const { slug } = action.payload;
            state.loadingStatuses[slug] = LOADING_STATUSES.ERROR;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        cancelSubscription: (state, action: PayloadAction) => {
            // saga only
        },
    },
});

export const subscriptionModalActions = slice.actions;
export const subscriptionModalReducer = slice.reducer;
